import { isUndefinedNullOrEmpty } from '../utils';

const getAgent = (state, agentId) => state.agents.value.get(agentId);

export const isAgentConnected = (state, agentId) => {
    const agent = getAgent(state, agentId);
    return !isUndefinedNullOrEmpty(agent) && agent.status.connected === 'connected';
};

export const agentRequiresUpgrade = (state, agentId) => {
    const agent = getAgent(state, agentId);
    return !isUndefinedNullOrEmpty(agent) && agent.status.requiresUpgrade === true;
};



// WEBPACK FOOTER //
// ./src/js/projections/agents.js